export default __webpack_public_path__ + "static/media/arrowwhite.609d625e.svg";